import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export const ArrayData = [
  {
    id: 5000,
    text: "Home",
    open: true,
    icon: <HomeOutlinedIcon />,
    menu: [
      {
        menuId: 5001,
        text: "Client List",
        navigateToURL: "/clients",
        parentMenuId: 5000
      },
      {
        menuId: 5002,
        text: "Client Setup",
        navigateToURL: "/clients/setup",
        parentMenuId: 5000
      },
      // {
      //   menuId: 5003,
      //   text: "Accountant List",
      //   navigateToURL: "/accountants",
      //   parentMenuId: 5000
      // },
    ],
  },
  {
    id: 100000,
    text: "Logout",
    icon: <LogoutOutlinedIcon />,
    navigateToURL: "/logout",
  },
];
